<template>
    <div class="testers-modal-wrap">
        <button class="btn btn-primary text-decoration-none mb-4" :disabled="requirements.length < 1"
                v-b-modal="'modal-extra'">{{$t('requirements.button')}}
        </button>
        <b-modal :id="'modal-extra'" :modal-class="'modal-extra'" centered hide-header hide-footer v-model="modalShow">
            <div class="modal-heading d-flex justify-content-between">
                <h3>{{$t('requirements.modal_title')}}</h3>
                <span class="pils all-results" v-if="!_.isNull(participantsCount) || areParticipantsCounting">
                    <b-spinner small v-if="areParticipantsCounting"></b-spinner>
                    <span v-else>{{participantsCount.toLocaleString()}}  </span>participants</span>
                <a href="javascript:;" @click="$bvModal.hide('modal-extra')" class="btn-close"><em
                        class="icon-delete"></em></a>
            </div>
            <!--<div class="modal-search-bar">-->
            <!--<b-input-group inline>-->
            <!--<label for="modal-search">-->
            <!--<svg aria-hidden="true" width="16" height="16" viewBox="0 0 512 512" focusable="false"-->
            <!--class="icon fa-icon">-->
            <!--<g>-->
            <!--<path d="M505 442.7c9.3 9.4 9.3 24.6-0.1 34l-28.3 28.3c-9.3 9.4-24.5 9.4-33.9 0l-99.7-99.7c-4.5-4.5-7-10.6-7-17v-16.3c-35.3 27.6-79.7 44-128 44-114.9 0-208-93.1-208-208s93.1-208 208-208 208 93.1 208 208c0 48.3-16.4 92.7-44 128h16.3c6.4 0 12.5 2.5 17 7zM208 336c70.8 0 128-57.3 128-128 0-70.8-57.3-128-128-128-70.8 0-128 57.3-128 128 0 70.8 57.3 128 128 128z"></path>-->
            <!--</g>-->
            <!--</svg>-->
            <!--</label>-->
            <!--<b-form-input-->
            <!--id="modal-search"-->
            <!--v-model="modalSearch"-->
            <!--type="search"-->
            <!--required-->
            <!--placeholder="Search for screeners"-->
            <!--&gt;</b-form-input>-->
            <!--</b-input-group>-->
            <!--</div>-->
            <div class="modal-content" v-if="!modalSearch">
                <div class="modal-content-tab-wrap">
                    <b-tabs :class="[selectedTab.length ? 'active-mobile' : '']" card vertical>
                        <b-tab :active="selectedTab === 'cat-' + k" v-for="(item, k) in requirements"
                               :key="'cat-' + k ">
                            <template #title>
								<span class="opener-text" @click="switchTab('cat-' + k, null, true)">
									<span class="text">{{getTranslation(item.category)}}</span>
                                    <span class="info-bubble" v-if="item.calculateSelectedRequirements() > 0">{{item.calculateSelectedRequirements()}}</span>
									<span class="forward only-mobile"><svg aria-hidden="true" width="20" height="20"
                                                                           viewBox="0 0 20 20" focusable="false"><g><path
                                            d="M15 10l-8.202 8.333-.965-.98L13.07 10 5.833 2.647l.965-.98L15 10Z"></path></g></svg></span>
								</span>
                            </template>
							<transition name="modal-subtab-content">
								<div class="tabs-wrap" :id="'cat-' + k " v-if="selectedTab === 'cat-' + k">
									<div class="tab-content">
										<div class="back-holder only-mobile">
											<a href="javascript:;" class="btn-back"
											   @click="switchTab('cat-' + k, null, true); selectedTab = ''">
												<span class="back"><svg aria-hidden="true" width="10" height="16"
																		viewBox="0 0 320 512" focusable="false"
																		class="fa-icon"><g><path
														d="M34.5 239l194.4-194.3c9.4-9.4 24.6-9.4 33.9 0l22.7 22.7c9.4 9.4 9.4 24.5 0 33.9l-154 154.7 154 154.8c9.3 9.4 9.3 24.5 0 33.9l-22.7 22.7c-9.4 9.4-24.6 9.4-33.9 0l-194.3-194.4c-9.4-9.4-9.4-24.6 0-33.9z"></path></g></svg></span>
												<span>{{$t('requirements.back')}}</span>
											</a>
										</div>
										<div class="tab-content-wrap">
											<div v-for="(subcategory, kk) in item.subcategories" :key="'subcat-' + k + kk ">
												<strong class="title" v-if="subcategory.subcategory_key">{{getTranslation(subcategory.subcategory)}}</strong>
												<ul class="tab-subtab">
													<li v-for="requirement in subcategory.items"
														:key="'req-' + requirement.id">
														<a href="javascript:;"
														   @click="selectRequirement(requirement, 'cat-' + k)"
														   class="added">
													<span class="tablist-opener-text">
														<span>{{getTranslation(requirement.query_title)}}</span>
														<span class="notification"
															  v-if="requirement.hasSavedAttributes()">
															<span class="check"><svg aria-hidden="true" width="19"
																					 height="14" viewBox="0 0 20 15"
																					 focusable="false"><g><path
																	d="M6.66667 14.4999L20 1.51381L18.7879 0.333252L6.61397 12.1901L1.15942 6.87764L0 8.00686L6.66667 14.4999Z"></path></g></svg></span>
															<span>{{$t('requirements.added')}}</span>
														</span>
													</span>
															<span class="forward"><svg aria-hidden="true" width="20"
																					   height="20"
																					   viewBox="0 0 20 20"
																					   focusable="false"><g><path
																	d="M15 10l-8.202 8.333-.965-.98L13.07 10 5.833 2.647l.965-.98L15 10Z"></path></g></svg></span>
														</a>
													</li>
												</ul>
											</div>
										</div>
									</div>
									<transition name="modal-subtab-content">
										<div class="subtab-content active" v-if="selectedRequirement"
											 :key="'subtab-req-' + selectedRequirement.id"
											 :id="'subtab-' + selectedRequirement.id">
											<div class="back-holder">
												<a href="javascript:;" class="btn-back"
												   @click="closeSubTab('subtab-' + selectedRequirement.id, 'cat-' + k, false)">
												<span class="back"><svg aria-hidden="true" width="10" height="16"
																		viewBox="0 0 320 512" focusable="false"
																		class="fa-icon"><g><path
													d="M34.5 239l194.4-194.3c9.4-9.4 24.6-9.4 33.9 0l22.7 22.7c9.4 9.4 9.4 24.5 0 33.9l-154 154.7 154 154.8c9.3 9.4 9.3 24.5 0 33.9l-22.7 22.7c-9.4 9.4-24.6 9.4-33.9 0l-194.3-194.4c-9.4-9.4-9.4-24.6 0-33.9z"></path></g></svg></span>
													<span>{{$t('requirements.back')}}</span>
												</a>
											</div>
											<div class="tab">
												<div class="tab-text-info">
													<h3>{{getTranslation(selectedRequirement.query_title)}}</h3>
													<p v-if="getTranslation(selectedRequirement.query_question)">
														{{$t('requirements.participants_were_asked', {question:
															getTranslation(selectedRequirement.query_question)})}}</p>
													<p v-if="selectedRequirement.type === 'select'">
														{{$t('requirements.select_attributes_or')}}
														<a href="javascript:;"
														   @click="selectedRequirement.selectAllAttributes()">{{$t('requirements.select_all')}}</a>
													</p>
												</div>
												<b-form-input
													v-model="modalTabSearch"
													v-if="selectedRequirement.type === 'select'"
													type="search"
													required
													class="subtab-search"
													:placeholder="$t('requirements.type_to_search')"
												></b-form-input>
												<ul class="tab-subtab" v-if="selectedRequirement.type === 'select'">
													<li v-for="attribute in filteredAttributes(selectedRequirement.attributes)">
														<b-form-checkbox
															v-model="selectedRequirement.selectedAttributes"
															:value="attribute.id"
														>
															{{getTranslation(attribute.label)}}
															<span class="selected"><svg
																aria-hidden="true" width="14"
																height="14" viewBox="0 0 512 512"
																focusable="false" class="fa-icon"><g><path
																d="M173.9 439.4l-166.4-166.4c-10-10-10-26.2 0-36.2l36.2-36.2c10-10 26.2-10 36.2 0l112.1 112.1 240.1-240.1c10-10 26.2-10 36.2 0l36.2 36.2c10 10 10 26.2 0 36.2l-294.4 294.4c-10 10-26.2 10-36.2 0z"></path></g></svg></span>
														</b-form-checkbox>
													</li>
												</ul>
												<div class="tab-subtab" v-if="selectedRequirement.type === 'range'">
													<b-form-group
														:label="getTranslation(selectedRequirement.minAttribute().label)"
														:label-for="selectedRequirement.id + '_min'">
														<div class="b-select-holder">
															<b-form-select trim :id="selectedRequirement.id + '_min'"
																		   text-field="label"
																		   v-model="selectedRequirement.min">
																<option v-for="val in selectedRequirement.minValues()"
																		:disabled="val > selectedRequirement.max">
																	{{ val }}
																</option>
															</b-form-select>
														</div>
													</b-form-group>
													<b-form-group
														:label="getTranslation(selectedRequirement.maxAttribute().label)"
														:label-for="selectedRequirement.id + '_max'">
														<div class="b-select-holder">
															<b-form-select trim :id="selectedRequirement.id + '_max'"
																		   text-field="label"
																		   v-model="selectedRequirement.max">
																<option v-for="val in selectedRequirement.maxValues()"
																		:disabled="val < selectedRequirement.min">
																	{{ val }}
																</option>
															</b-form-select>
														</div>
													</b-form-group>
												</div>
											</div>
											<div class="btns-holder">
												<div class="btns-box">
													<button class="btn btn-cancel btn-sm"
															@click="selectedRequirement.removeSelectedAttributes(removeSelectedAttributes)"
															:disabled="!selectedRequirement.hasAttributesToRemove()">
														{{$t('requirements.remove')}}
													</button>
													<span class="notification" v-if="justRemoved">
													<span class="check"><svg aria-hidden="true" width="19" height="14"
																			 viewBox="0 0 20 15" focusable="false"><g><path
														d="M6.66667 14.4999L20 1.51381L18.7879 0.333252L6.61397 12.1901L1.15942 6.87764L0 8.00686L6.66667 14.4999Z"></path></g></svg></span>
													<span>{{$t('requirements.removed')}}</span>
												</span>
												</div>
												<div class="btns-box">
												<span class="notification" v-if="justApplied">
													<span class="check"><svg aria-hidden="true" width="19" height="14"
																			 viewBox="0 0 20 15" focusable="false"><g><path
														d="M6.66667 14.4999L20 1.51381L18.7879 0.333252L6.61397 12.1901L1.15942 6.87764L0 8.00686L6.66667 14.4999Z"></path></g></svg></span>
													<span>{{$t('requirements.applied')}}</span>
												</span>
													<button class="btn btn-outline-primary btn-sm submit mr-2"
															@click="selectedRequirement.applySelectedAttributes(applySelectedAttributes)"
															:disabled="!selectedRequirement.hasSelectedAttributeToApply()">
														{{$t('requirements.apply')}}
													</button>
													<button class="btn btn-primary btn-sm submit"
															@click="done">
														{{$t('requirements.done')}}
													</button>
												</div>
											</div>
										</div>
									</transition>
								</div>
							</transition>
                        </b-tab>
                    </b-tabs>
                </div>
            </div>
            <div class="modal-content" v-else>
                <!--SEARCH-->
                <!--TBD later-->
            </div>
        </b-modal>
		<b-card class="tester-card" v-for="requirement in filledRequirements" :key="'freq-'+ requirement.id">
			<b-card-text>
				<p><b class="title">{{requirement.label}}</b></p>
				<p>{{requirement.attrs.join(', ')}}</p>
				<a href="javascript:;" @click="requirement.remove(removeSelectedAttributes)" class="btn-close"><em
					class="icon-delete"></em>
				</a>
			</b-card-text>
		</b-card>
    </div>
</template>

<script>
    import isObject from 'lodash/isObject';
    import isString from 'lodash/isString';
    import map from 'lodash/map';
    import includes from 'lodash/includes';
    import startsWith from 'lodash/startsWith';
    import cloneDeep from 'lodash/cloneDeep';
    import concat from 'lodash/concat';
    import AudienceCategory from "../../classes/models/AudienceCategory";
    import VueSlider from 'vue-slider-component'
    import 'vue-slider-component/theme/default.css';
    import {mapGetters} from 'vuex';

    export default {
        name: 'tests-wizard-modal',
        components: {VueSlider},
        props: {
            rawRequirements: Array,
            testSelectedAttributes: Array,
        },
        data() {
            return {
                modalSearch: '',
                modalTabSearch: '',
                checkbox: [],
                lang: this.$root.lang,
                selectedTab: (window.outerWidth < 768) ? '' : 'cat-0',
                selectedRequirement: null,
                modalShow: false,
                justApplied: false,
                justRemoved: false,
                selectedAttributes: this.testSelectedAttributes || [],
            }
        },
        methods: {
            selectRequirement(requirement, parentId) {
                this.resetRequirementTab(requirement);
                const parent = document.getElementById(parentId);
                parent.classList.add("active");
            },
            closeSubTab(elementId, parentId, mobile) {
                const element = document.getElementById(elementId),
                    parent = document.getElementById(parentId);
                let intViewportWidth = window.innerWidth;
                if (element) {
                    element.classList.remove("active");
                }
                if (parent) {
                    parent.classList.remove("active");
                }
                if (intViewportWidth < 768 && mobile === true) {
                    if (elements[0].closest('.tabs.row').classList.contains("active-mobile")) {
                        elements[0].closest('.tabs.row').classList.remove("active-mobile");
                    }
                    else {
                        elements[0].closest('.tabs.row').classList.add("active-mobile");
                    }
                }
                this.resetRequirementTab();
            },
            getTranslation(line) {
                if (isObject(line) && line[this.lang]) {
                    return line[this.lang];
                }
                if (isString(line)) {
                    return line;
                }

                return '';
            },
            switchTab(elementId) {
                this.resetRequirementTab();
                this.selectedTab = elementId;
                this.$nextTick(() => {
                    const elements = document.querySelectorAll('.subtab-content');
                    elements.forEach(el => el.classList.remove("active"));
                });

            },
            filteredAttributes(attributes) {
                const search = this.modalTabSearch;
                if (!search) {
                    return attributes;
                }
                return attributes.filter(item => startsWith(this.getTranslation(item.label).toLowerCase(), search.toLowerCase()));
            },
            applySelectedAttributes(selectedAttributes, allAttributeIds) {
                this.selectedAttributes = _.filter(this.selectedAttributes, attributeId => {
                    if (_.isObject(attributeId)) {
                        attributeId = attributeId.id;
                    }
                    return !includes(allAttributeIds, attributeId);
                });
                this.selectedAttributes = concat(this.selectedAttributes, selectedAttributes);
                this.justApplied = true;
                this.$emit('input', this.selectedAttributes);
            },
            removeSelectedAttributes(allAttributeIds) {
                this.selectedAttributes = _.filter(this.selectedAttributes, attributeId => {
                    if (_.isObject(attributeId)) {
                        attributeId = attributeId.id;
                    }
                    return !includes(allAttributeIds, attributeId);
                });
                this.justRemoved = true;
                this.$emit('input', this.selectedAttributes);
            },
            resetRequirementTab(requirement) {
                this.justApplied = false;
                this.selectedRequirement = requirement || null;
                this.modalTabSearch = '';
            },
            done() {
                if (this.selectedRequirement && this.selectedRequirement.hasSelectedAttributeToApply()) {
                    this.selectedRequirement.applySelectedAttributes(this.applySelectedAttributes);
                }
                this.modalShow = false;
            }
        },
        computed: {
            requirements() {
                return map(cloneDeep(this.rawRequirements), category => {
                    let categoryModel = new AudienceCategory(category);
                    categoryModel.updateSubcategoriesSelectedAttributes(this.selectedAttributes);

                    return categoryModel;
                });
            },
            filledRequirements() {
                let requirements = [];
                _.each(this.requirements, category => {
                    if (category.category_key === 'Recommended' || category.calculateSelectedRequirements() < 1) {
                        return;
                    }
                    let categoryRequirements = _.flatMap(category.subcategories, subcategory => subcategory.items);

                    _.each(categoryRequirements, requirement => {
                        if (requirement.hasSavedAttributes()) {
                            requirements.push({
                                label: this.getTranslation(requirement.query_title),
                                type: requirement.type,
                                id: requirement.id,
                                attrs: _(this.selectedAttributes).map(attr => {
                                    let attribute = _.find(requirement.attributes, a => (_.isObject(attr) ? attr.id : attr) === a.id);
                                    if(!attribute) {
                                        return null;
                                    }
                                    switch (requirement.type) {
                                        case 'range':
                                            return this.getTranslation(attribute.label) + ': ' + attr.value;
                                        default:
                                            return this.getTranslation(attribute.label)
                                    }


                                }).omitBy(_.isEmpty).values().value(),
                                remove: (cb) => {
                                    requirement.removeSelectedAttributes(cb);
                                }
                            });
                        }
                    });
                });

                return requirements;
            },
            ...mapGetters({
                participantsCount: 'options/participantsCount',
                areParticipantsCounting: 'options/areParticipantsCounting',
            }),
        },
        watch: {
            modalShow: {
                handler(val) {
                    if (!val) {
                        this.resetRequirementTab();
                    }
                }
            },
            justApplied: {
                handler(val) {
                    if (val) {
                        setTimeout(() => this.justApplied = false, 5000);
                    }
                }
            },
            justRemoved: {
                handler(val) {
                    if (val) {
                        setTimeout(() => this.justRemoved = false, 5000);
                    }
                }
            }
        }
    }
</script>

<style scoped>

</style>
